$(document).ready(function () {
    $(document).on('click', '.download-warning', function (event) {
        $(this).removeClass('download-warning');
        $(this).addClass('download-no-warning');

        // prevent default action
        event.preventDefault();

        var modal = $('#downloadWarningModal');

        // get href attribute of clicked element
        var href = $(this).attr('href');

        modal.find('.download').attr('href', href);

        // show modal
        modal.modal('show');
        modal.find('.download').on('click', function ()  {
            if (!modal.find('.hide-download-warning').is(':checked')) {
                let downloadNoWarning = $('.download-no-warning');
                downloadNoWarning.addClass('download-warning');
                downloadNoWarning.removeClass('download-no-warning');
            }

            modal.modal('hide');
        });
    });

    // if hideDownloadWarning is set to true, add warning to href to /1 to .download button in modal
    $(document).on('click', '.hide-download-warning', function (event) {
        var href = null;

        // if checkbox is checked
        if ($(this).is(':checked')) {
            href = $('.download').attr('href');
            href = href + '/warning';
            $('.download').attr('href', href);
        } else {
            href = $('.download').attr('href');
            href = href.replace('/warning', '');

            $('.download').attr('href', href);
        }
    });
});
